import { Typography } from '@material-ui/core';
import fullVendorList from '../data/vendors/processedVendors.json';

const VendorCatalogContainer = [
    {
        key: 'vendorCatalogContainer',
        type: 'catalog',
        sections: [
            {
                key: 'vendorCatalogSection',
                collection: 'vendorFiltersSorters',
                type: 'catalog',
                spacing: 4,
                cardMapping: {
                    subheader: {
                        field: 'vendorTypes',
                        className: ' vendorType'
                    },
                    media: {
                        field: 'imageURL',
                        className: ' vendorMedia'
                    },
                    cardContent: {
                        functions: [
                            (element) => {
                                return (
                                    <Typography>{element.vendorName}</Typography>
                                )
                            }
                        ]
                    },
                    buttonLink: {
                        field: 'vendorURL',
                        className: ' vendorButton',
                        buttonText: 'See Website'
                    }

                },
                elements: fullVendorList
            }
        ]
    }
]

const VendorFilterFieldGroups = [
    {
        key: 'vendorFiltersSorters',
        sections: [
            {
                key: 'vendorFiltersSortersSection',
                collection: 'vendorFiltersSorters',
                type: 'interactive',
                elements: [
                    {
                        key: 'evChargersPlugType',
                        type: 'buttonCluster',
                        buttonWidth: '33%',
                        property: 'vendorTypeFilter',
                        title: 'Vendor type',
                        buttons: [
                            {
                                name: 'Engineering',
                                action: 'Engineering'
                            },
                            {
                                name: 'Construction',
                                action: 'Construction'
                            },
                            {
                                name: 'Procurement',
                                action: 'Procurement'
                            }
                        ],
                        scaleOverrides: {
                            xs: 12,
                            md: 8
                        }
                    },
                    {
                        key: 'vendorSortBy',
                        property: 'vendorSortBy',
                        type: 'dropdown',
                        options: [
                            {
                                name: 'A - Z',
                                value: 'az'
                            },
                            {
                                name: 'Z - A',
                                value: 'za'
                            }
                        ],
                        title: 'Sort By',
                        tooltip: 'TBD',
                        scaleOverrides: {
                            xs: 12,
                            md: 3
                        }
                    }
                ]
            }
        ]
    }
]

const VendorCatalogToggle = [
    {
        key: 'fuelingAlternativeToggle',
        sections: [
            {
                key: 'fuelingAlternativeToggleButton',
                collection: 'vendorFiltersSorters',
                type: 'interactive',
                elements: [
                    {
                        key: 'fuelAlternativesToggle',
                        property: 'fuelType',
                        type: 'toggleTabs',
                        options: [
                            {name: 'Electric', action: 'electric', key: 'fuelType_electric'},
                            {name: 'Hydrogen', action: 'hydrogen', key: 'fuelType_hydrogen'}
                        ],
                        default: 'Electric'
                    }
                ]
            }
        ],
    }
]

const ElectricVendorCatalogData = [ 
    ...VendorCatalogToggle,
    ...VendorFilterFieldGroups, 
    ...VendorCatalogContainer
]
export default ElectricVendorCatalogData;